// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"102":"d7c57328","864":"2aa72173"}[chunkId] + ".chunk.css";
};